/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import {
  TextField,
  Typography,
  Container,
  Box,
  Alert,
} from '@mui/material';

import AccountBalanceRoundedIcon from '@mui/icons-material/AccountBalanceRounded';

import LoadingButton from '../../components/buttons/Buttons';

import { 
  VerifyCheque 
} from '../../redux/actions/chequeActions';


import "./styles.scss";

const Data = {
  cheque_number: '',
  payee_name: '',
  amount: '',
  cheque_date: '',
  routing_number: '',
  account_number: ''
};

const ChequeVerifyPage = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const [formData, setFormData] = useState(Data);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const formatNumber = (value) => {
    // Remove all non-numeric characters except decimal point
    const cleanValue = value.replace(/[^\d.]/g, '');
    
    // Ensure only one decimal point
    const parts = cleanValue.split('.');
    if (parts.length > 2) return parts[0] + '.' + parts.slice(1).join('');
    
    // Format with commas and 2 decimal places
    const num = parseFloat(cleanValue);
    if (isNaN(num)) return '';
    
    if (cleanValue.includes('.')) {
      const [integer, decimal] = cleanValue.split('.');
      return integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + decimal.slice(0, 2);
    }
    
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const handleAmountChange = (e) => {
    const formattedValue = formatNumber(e.target.value);
    setFormData(prev => ({
      ...prev,
      amount: formattedValue
    }));
  };

  const handleVerify = async () => {
    try {
      setError(false);
      setSuccess(false);

      // Convert amount back to number for API
      const payload = {
        ...formData,
        amount: parseFloat(formData.amount.replace(/,/g, ''))
      };

      await dispatch(VerifyCheque(payload, setLoading)).then(({res, statusCode}) => {
        if(statusCode === 200){
          setError(false);
          setSuccess(true);
        } else {
          setError(true);
          setSuccess(false);
        }
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Box 

        sx={{ my: 4, minHeight: "calc(100vh - 100px)" }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Check Verification
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Use this form to verify check details. Enter all required information carefully
          and click verify to validate the check against our system.
        </Typography>

        <Box  
          className="cheque flex__Column"
          sx={{ p: 3, mt: 3 }}>
          <Box 
            className="flexCenterSBRow">
            <Box className="flexCenter_Row">
              <AccountBalanceRoundedIcon 
                sx={{ color: "#c4c4c4" }}
                fontSize='large'/>
              <Box>
                <Box
                  sx={{ backgroundColor: "#c4c4c4", height: "15px", width: "200px", borderRadius: "12px", ml: 1, mb: 1 }}
                  />
                <Box
                  sx={{ backgroundColor: "#c4c4c4", height: "8px", width: "100px", borderRadius: "12px", ml: 1 }}
                  />
              </Box>
            </Box>
            <TextField
              label="Check Number"
              name="cheque_number"
              value={formData.cheque_number}
              onChange={handleChange}
              sx={{ width: "200px" }}
            />
          </Box>
          <Box 
            className="flexCenter_Row" 
            gap="10px">
            <TextField
              fullWidth
              label="Payee Name"
              name="payee_name"
              value={formData.payee_name}
              onChange={handleChange}
            />
            <TextField  
              label="Amount"
              name="amount"
              value={formData.amount}
              onChange={handleAmountChange}
              sx={{ minWidth: "200px" }}
              InputProps={{
                inputProps: { inputMode: 'numeric' }
              }}
            />
          </Box>
          <Box 
            className="flexCenterSBRow">
            <Box />
            <TextField
              label="Check Date"
              name="cheque_date"
              type="date"
              value={formData.cheque_date}
              onChange={handleChange}
              sx={{ width: "200px" }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
            
          <Box 
            className="flexCenterCenterRow" 
            gap="10px">
            <TextField
              label="Routing Number"
              name="routing_number"
              value={formData.routing_number}
              onChange={handleChange}
              sx={{ minWidth: "300px", maxWidth: "300px" }}
            />
            <TextField
              label="Account Number"
              name="account_number"
              value={formData.account_number}
              onChange={handleChange}
              sx={{ minWidth: "300px", maxWidth: "300px" }}
            />
          </Box>

            <LoadingButton
              variant="contained"
              onClick={handleVerify}
              loading={loading}
              disabled={(!formData.cheque_number || !formData.payee_name || !formData.amount || !formData.cheque_date || !formData.routing_number || !formData.account_number)}
              fullWidth
              sx={{ mt: 2 }}
            >
              Verify Check
            </LoadingButton>
        </Box>
        <Box
          mt={"30px"}
          className="flexCenterCenterColumn"
          gap={"10px"}>
          {
            (error || success)
            &&
            <Typography>
              Verification result
            </Typography>
          }
          <Box
            width={"100%"}>
            {error && (
              <Alert severity="error">
                <b>Invalid Check</b>
                <Box>
                  Please ensure that all the fields are exactly like on the check, including the preceding zeros on Check number, Routing number and Account number.
                </Box>
              </Alert>
            )}
            {success && (
              <Alert severity="success">
                <b>Check verified successfully!</b>
              </Alert>
            )}
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ChequeVerifyPage;